import { render } from "./DefenseArmoryCardComponent.vue?vue&type=template&id=035b6999&scoped=true"
import script from "./DefenseArmoryCardComponent.vue?vue&type=script&lang=js"
export * from "./DefenseArmoryCardComponent.vue?vue&type=script&lang=js"

import "./DefenseArmoryCardComponent.vue?vue&type=style&index=0&id=035b6999&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035b6999"]])

export default __exports__